module.exports = __webpack_public_path__ + "static/media/bg6.39989975.jpg";